import '.d{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.p{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.cp{background:var(--shades-white);}.ssr-plugin'
import '.bs{flex-grow:1;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.b1{max-width:77.5rem;}.ssr-plugin'
import '.dn{justify-content:stretch;}.ssr-plugin'
import '.do{position:sticky;}.ssr-plugin'
import '.cj{top:0;}.ssr-plugin'
import '.dp{z-index:10;}.ssr-plugin'
import '.dq{padding-block:1rem;}.ssr-plugin'
import '.dr{height:3rem;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.da{flex-wrap:wrap;}.ssr-plugin'
import '.ds{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bg{margin-top:2rem;}.ssr-plugin'
import '.gc{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d ab p e cp"
      >
        <div className="bs d b p e"
        >
          <div className="b1 d e dn do cj dp"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dq dr d a3 b da"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ds d e ab bg gc b1"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
